const BaseComponent = require('base/base-component');
const Server = require('helper/server');

const listTpl = Handlebars.templates['common/home/templates/panel'];

module.exports = class extends BaseComponent {
  init () {
    this.$pieChart = this.$el.find('.chart');
    this.$chartInfo = this.$el.find('.chart-info');
    this.$agencyList = this.$el.find('.agency-list');
    this.fetchData();
  }

  fetchData () {
    Server.getCMSData('agencyCount').then((resp) => {
      const data = typeof resp == 'string' ? JSON.parse(resp) : resp;
      if (data.success === true) {
        const { provCount, otherCount, totalCount } = data.result;
        this.initPieChart(provCount, otherCount, totalCount);
        this.$chartInfo.find('.province').text(provCount);
        this.$chartInfo.find('.other').text(otherCount);
      }
    });
    Server.getCMSData('homeAgencyList').then((resp) => {
      const data = typeof resp == 'string' ? JSON.parse(resp) : resp;
      const detailPage = this.$el
        .find('.card__link')
        .attr('href')
        .replace('index.html', 'detail.html');
      if (!data || !data.data) {
        return;
      }
      data.data = data.data.map(item => $.extend({}, item, { url: `${detailPage}?orgId=${item.id}` }));
      data.active = true;
      this.$agencyList.append(listTpl(data));
    });
  }

  initPieChart (provCount, otherCount, total) {
    let myChart = echarts.init(this.$pieChart[0]);
    const option = {
      title: {
        text: `${total}\nNUMBER`,
        left: 'center',
        top: 'center',
        // padding: [20, 0],
        textStyle: {
          color: '#3E9E65',
          fontSize: 18,
          align: 'center'
        }
      },
      tooltip: {
        trigger: 'item',
        position (pos, params, dom, rect, size) {
          // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
          let obj = { top: 60 };
          obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 100;
          return obj;
        },
        formatter: '{b} <br/>{a}: {c}'
      },
      legend: null,
      series: [
        {
          name: '市场份额',
          type: 'pie',
          radius: ['50%', '80%'],
          avoidLabelOverlap: false,
          color: ['#9DD7B5', '#3A9F63'],
          label: {
            normal: {
              show: false,
              position: 'center'
            },
            emphasis: {
              show: false
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [{ value: otherCount, name: '省外' }, { value: provCount, name: '省内' }]
        }
      ]
    };
    if (option && typeof option === 'object') {
      myChart.setOption(option, true);
    }
  }
};
